module.exports = __webpack_public_path__ + "img/Marca22.a4f70736.jpg";